import React from 'react';
const TituloSolo = () => {

  return (
    <section 
      className="page-title-section top-position1 bg-img cover-background left-overlay-dark" 
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/bg-gracias.jpg)` }} 
      data-overlay-dark="8"
    >
      <div className="container">
        <div className="page-title mx-1-6 mx-lg-2-0 mx-xl-2-6 mx-xxl-2-9">
          <div className="row">
            <div className="col-md-12">
                  <h1>Hemos recibido tu mensaje</h1> 
            </div>
            <div className="col-md-12">
                 <p className="mb-0 text-white">
                   Nuestro equipo te contactará para proporcionarte más información.
                  </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TituloSolo;